import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { RoleManagementPage } from "src/components/views/users/roleManagement/RoleManagementPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/users/roles")({
	staticData: { title: i18n.t("roles"), legacyViewKey: "roleManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <RoleManagementPage />;
}
